<template>
  <div class="orders">
    <div>
      <van-nav-bar title="订单确认" @click-left="onClickLeft" left-arrow />
    </div>
    <div class="content">
      <ul>
        <li v-for="(item, index) in productList" :key="index">
          <div class="content_head pay-radius">
            <van-row>
              <van-col>
                <img :src="item.mainPictureUrl" alt />
              </van-col>
              <van-col class="head_title" span="17">
                {{ item.title }}
                <div
                  v-for="(items, i) in item.productSpecificationsVos"
                  :key="i"
                >
                  {{ items.productAttributeName }}{{ items.val }}
                </div>
                <div class="head_price">
                  <div class="flex-price">
                    <div class="head-beforeMoney">
                      ￥{{ item.price }}
                      <span class="price-beforeMoney"
                        >￥{{ item.marketPrice }}</span
                      >
                    </div>
                    <div class="price-num">X{{ item.quantity }}</div>
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
        </li>
      </ul>
      <div class="power_content pay-allradius">
        <div class="power_show">
          服务方式
          <div>
            <!-- 服务方式 -->
            <span v-if="nowExpress.deliveryMethod == 1" class="from-store"
              >快递</span
            >
            <span v-else class="from-store">同城</span>
          </div>
        </div>

        <div class="power_detail">
          <p>收货人:&ensp;{{ shopAddressList.contacts }}</p>
          <p>
            联系电话:
            <span>{{ shopAddressList.phoneNumber }}</span>
          </p>
          <p class="store-address">
            收货地址:{{ streetvalue }}{{ shopAddressList.detailsAddress }}
          </p>
          <div class="again_store">
            <span @click="modify">修改</span>
            <span @click="toAddAddress">&emsp;|&emsp;添加新地址</span>
          </div>
        </div>
      </div>
      <div class="pay_remark pay-allradius">
        <van-field
          v-model="text"
          @input="payNote"
          label="订单备注"
          placeholder="选填"
        />
      </div>
      <div
        v-if="payList.name && payList.couponVos.length > 0"
        class="pay-cards pay-cardradius"
      >
        <choice-card
          @getCouponArray="getCouponArray"
          :payList="payList"
          :useCoupon="useCoupon"
          @againSelect="againSelect"
          @nameArray="nameArray"
        />
      </div>
      <div class="pay_num pay-total">
        <div class="pay_title">商品金额</div>
        <div class="pay_now pay_title" style="color: black">
          ￥{{ payList.totalAmount }}
        </div>
      </div>
      <gold-coins
        class="pay_num"
        ref="goldCoins"
        :payList="payList"
        @useGoldClick="useGoldClick"
        @zeroGoldClick="zeroGoldClick"
      />
      <div class="pay_num">
        <div class="pay_title">运费</div>
        <div
          class="pay_now pay_title"
          style="color: black; padding-bottom: 3px"
        >
          +&ensp;￥{{ payList.freightAmount }}
        </div>
      </div>
    </div>
    <div class="onsubmit">
      <van-submit-bar
        :disabled="hasSubmit"
        class="submit_main"
        :suffix-label="expressMoneys"
        :label="getAge"
        @submit="onSubmit"
        button-color="#ff3300"
        :price="preferentialPrice"
        button-text="提交订单"
      />
    </div>
    <toast-show :showMessage="showMessage" :showToast="showToast" />
  </div>
</template>

<script>
import toastShow from '@/components/content/toastShow'
import { submissionOrdersV2, settlement, toPayV2 } from '@/api/productsDetaile'
import { PRODUCT_ENQUIRY } from '@/config/platformtype'
import { FRONTEND_HOST } from '@/config/domainnameconstant'
import filterStreet from '@/mixins/filterStreet'
import getIsWx from '@/mixins/getIsWx'
import choiceCard from '@/components/content/choiceCard'
import goldCoins from '@/components/content/goldCoins'
import Cookies from 'js-cookie'

export default {
  mixins: [filterStreet, getIsWx],
  data() {
    return {
      nameShow: true,
      hasResult: true,
      getObj: {},
      getCardsArray: [],
      useCoupon: true,
      userCode: '',
      hasSubmit: false,
      switchingServices: false,
      province: '',
      nowExpress: {},
      skuArrs: [],
      arrVal: '',
      getArrId: [],
      payList: {},
      productList: [],
      preferentialPrice: 0,
      phoneList: [],
      productListItem: [],
      payTime: [],
      shopAddressList: [],
      amend: 2,
      showMessage: '',
      showToast: false,
      warn: false,
      showRadio: true,
      showMode: false,
      value1: '1',
      option1: [
        { text: '快递', value: '1' },
        { text: '同城', value: '2' },
      ],
      columns: [
        '青秀区星湖路店',
        '江南区百花店',
        '江南区百花店',
        '江南区百花店',
      ],
      age: 0,
      text: '',
      message: '',
      radio: '',
    }
  },
  components: {
    toastShow,
    choiceCard,
    goldCoins,
  },
  computed: {
    // 底部快递费用
    expressMoneys() {
      if (this.nowExpress.deliveryMethod === 1) {
        return '快递费' + this.payList.freightAmount + '元'
      } else {
        return ''
      }
    },
    // 底部总计几件
    getAge() {
      return '共' + this.age + '件,合计'
    },
  },
  created() {
    this.getArrId = this.$route.query.items
    this.nowExpress = this.$route.query
    this.getObj = {
      cartItemIds: JSON.parse(this.nowExpress.items),
      shippingAddressId: this.nowExpress.shippingAddressId,
      useCoupon: this.useCoupon,
      useGold: true,
      useGoldCount: 0,
    }
    this.getConfirmation(this.getObj)
    window.document.title = '订单确认'
  },
  mounted() {
    if (this.$getIsApp()) {
      this.$callApp('iOS', 'HiddenTabBarMethod', '')
    }
  },
  methods: {
    // 金币清零
    zeroGoldClick() {
      this.getObj.useGoldCount = 0
      this.getConfirmation(this.getObj)
    },
    // 金币弹窗关闭使用金币
    useGoldClick(val) {
      this.getObj.useGoldCount = Number(val)
      this.getConfirmation(this.getObj)
    },
    nameArray(nameArray) {
      this.nameShow = nameArray
    },
    againSelect() {
      // delete this.getObj.useGoldCount
      this.getObj.useGoldCount = 0
      this.getConfirmation(this.getObj)
    },
    getCouponArray(val) {
      console.log('getCouponArray', val)
      this.getCardsArray = val
      if (val.length === 0) {
        this.getObj.couponHistoryIds = []
        // delete this.getObj.useGoldCount
        this.getObj.useGoldCount = 0
        this.getConfirmation(this.getObj)
        this.hasResult = false
      } else {
        // delete this.getObj.useGoldCount
        this.getObj.useGoldCount = 0
        this.getObj.couponHistoryIds = val
        this.getConfirmation(this.getObj)
      }
      // 控制金币子组件勾选取消
      this.$refs.goldCoins.changeGoldChecked()
    },
    changeValue(value) {
      this.nowExpress.deliveryMethod = value
      if (this.nowExpress.deliveryMethod === 1) {
        this.hasSubmit = false
      }
      this.getConfirmation(this.getObj)
    },
    // 添加新地址跳转
    toAddAddress() {
      if (this.nowExpress.fromcart) {
        delete this.nowExpress.fromcart
      }
      // //判断同城范围是否纯在，不在则localStorage
      if (
        this.nowExpress.deliveryMethod === 2 &&
        !window.localStorage.getItem('distributionScope')
      ) {
        window.localStorage.setItem(
          'distributionScope',
          this.productList[0].cityDistributionScope
        )
      }
      this.$router.push({
        path: '/mall/add-address',
        query: {
          status: this.amend,
          storeId: this.nowExpress.storeId,
          items: this.getArrId,
          deliveryMethod: this.nowExpress.deliveryMethod,
        },
      })
    },
    // 修改地址
    modify() {
      const query = {}
      const addressMessage = {
        addressCode: this.shopAddressList.addressCode,
        contacts: this.shopAddressList.contacts,
        detailsAddress: this.shopAddressList.detailsAddress,
        firstChoice: this.shopAddressList.firstChoice,
        id: this.shopAddressList.id,
        phoneNumber: this.shopAddressList.phoneNumber,
        status: this.amend,
      }
      if (this.nowExpress.fromcart) {
        delete this.nowExpress.fromcart
      }
      // //判断同城范围是否纯在，不在则localStorage
      if (
        this.nowExpress.deliveryMethod === 2 &&
        !window.localStorage.getItem('distributionScope')
      ) {
        window.localStorage.setItem(
          'distributionScope',
          this.productList[0].cityDistributionScope
        )
      }
      Object.assign(query, this.nowExpress, addressMessage)
      console.log('queryquery', query)

      this.$router.push({
        path: '/mall/editaddress',
        query: query,
      })
    },
    // 订单备注
    payNote(val) {
      this.text = val
    },
    unique(arr) {
      const res = new Map()
      return arr.filter((a) => !res.has(a) && res.set(a, 1))
    },
    // 去结算
    getConfirmation(getObj) {
      this.hasSubmit = true
      const loading = this.$toast.loading({
        overlay: true,
        forbidClick: true,
        duration: 0,
        message: '请稍等...',
      })
      settlement(getObj).then((res) => {
        if (res.data.code === 200) {
          loading.clear()
          this.hasSubmit = false
          // 拿到默认选择优惠劵的名字
          if (res.data.data.couponVos && this.hasResult && this.nameShow) {
            const cardItemName = []
            res.data.data.couponVos.forEach((item) => {
              if (item.choose) {
                cardItemName.push(item.couponName)
              }
            })
            res.data.data.cardItemName = cardItemName.toString()
            console.log(
              'res.data.data.cardItemName111',
              res.data.data.cardItemName
            )
          }
          // 默认拿到优惠劵组合
          if (res.data.data.couponCombinations && this.hasResult) {
            this.getCardsArray = []
            res.data.data.couponCombinations.forEach((el) => {
              console.log('ell`````````', el)
              el.forEach((item) => {
                console.log('``````item', item)
                if (item.choose) {
                  this.getCardsArray.push(item.id)
                  console.log(
                    'this.getCardsArraythis.getCardsArray',
                    this.getCardsArray
                  )
                }
              })
            })
            this.getCardsArray = this.unique(this.getCardsArray)
          }
          this.payList = res.data.data
          this.productList = this.payList.confirmOrderItemVo.confirmProductVos
          this.shopAddressList = this.payList.shippingAddressVo
          this.getStreetArray(this.shopAddressList.addressCode)
          console.log('快递', this.shopAddressList)
          // 获取用户选的地址code
          this.userCode = this.shopAddressList.addressCode
          if (
            this.nowExpress.deliveryMethod === 2 &&
            this.productList[0].cityDistributionScope
          ) {
            const cityCodeArr = this.productList[0].cityDistributionScope.split(
              ','
            )
            console.log('cityCodeArr', cityCodeArr)

            // 判断是否符合配送范围
            const exist = cityCodeArr.indexOf(this.userCode) !== -1
            console.log('exist', exist)
            if (!exist) {
              this.hasToast(
                '您选择地区不在配送范围请确认产品配送范围或者修改地址'
              )
              this.hasSubmit = true
            }
          }

          console.log('yes完成1', this.payList)
          this.age = 0
          for (const index in this.productList) {
            // 合计循环
            this.age += this.productList[index].quantity
          }
          this.arrVal = []
          this.skuArrs = []
          this.arrVal = this.productList.map((el, i) => {
            console.log('dddd', el, i)
            const objs = {}
            objs.productSkuId = el.id
            objs.quantity = el.quantity
            this.skuArrs.push(objs)
            return this.skuArrs
          })
          // 判断是否可切换服务方式
          this.switchingServices = this.productList.every(
            (items, index, arr) => {
              let switchArry
              if (items.deliveryMethod) {
                switchArry = items.deliveryMethod.split(',')
              }
              return switchArry.length > 1
            }
          )
          if (this.switchingServices) {
            this.value1 = this.nowExpress.deliveryMethod + ''
          }
          console.log('this.switchingServices', this.switchingServices)
          console.log(' this.skuArrs', this.skuArrs)
          this.preferentialPrice = this.payList.payAmount * 100
          this.payList.name = 'orderCart'
        } else {
          loading.clear()
        }
      })
      // .finally(() => loading.clear())
    },
    // 接口最后
    // 提交订单接口
    onSubmit() {
      const loading = this.$toast.loading({
        overlay: true,
        forbidClick: true,
        duration: 0,
        message: '下单中...',
      })
      console.log(
        'this.$route.query.shippingAddressId',
        this.nowExpress.shippingAddressId
      )

      submissionOrdersV2({
        platformType: PRODUCT_ENQUIRY,
        shippingAddressId: this.nowExpress.shippingAddressId,
        submitProductVos: this.skuArrs,
        storeId: this.nowExpress.storeId,
        note: this.text,
        deliveryMethod: this.nowExpress.deliveryMethod,
        useCoupon: this.useCoupon,
        couponHistoryIds: this.getCardsArray,
        useGold: true,
        useGoldCount: this.getObj.useGoldCount,
      })
        .then((res) => {
          if (res.data.code === 200) {
            loading.clear()
            const Data = res.data.data
            console.log('Data', Data)
            Data.deliveryMethod = this.nowExpress.deliveryMethod
            if (Data.certificationType === 1) {
              this.$router.push({
                path: '/themepage/PaymentTransition',
                query: Data,
              })
              return
            }
            let toPayRequestVo = {}
            if (Data.certificationType === 0) {
              toPayRequestVo = {
                orderId: Data.orderId,
                payType: '5',
              }
            }

            console.log('toPayRequestVo', toPayRequestVo)
            toPayV2(toPayRequestVo)
              .then((res) => {
                if (res.data.code === 200) {
                  console.log('去支付成功', res.data.data)
                  let payData = {
                    payData: res.data.data.payData,
                    orderId: res.data.data.orderId,
                    certificationType: res.data.data.certificationType,
                    payType: res.data.data.payType,
                  }
                  if (res.data.data.needPay) {
                    if (this.$isWeixin()) {
                      const successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}`
                      const failReturnUrl = `${FRONTEND_HOST}/themepage/error?id=${payData.orderId}`
                      window.location.href =
                        payData.payData +
                        `&successReturnUrl=${encodeURIComponent(
                          successReturnUrl
                        )}&failReturnUrl=${encodeURIComponent(failReturnUrl)}`
                    } else {
                      const analysis = JSON.parse(payData.payData)
                      let token = ''
                      if (Cookies.get('token')) {
                        token = Cookies.get('token')
                        const successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}&token=${token}`
                        window.location.href =
                          analysis.MwebUrl +
                          `&redirect_url=${encodeURIComponent(
                            successReturnUrl
                          )}`
                      } else {
                        const successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}`
                        window.location.href =
                          analysis.MwebUrl +
                          `&redirect_url=${encodeURIComponent(
                            successReturnUrl
                          )}`
                      }
                    }
                  } else {
                    window.location.href = `${FRONTEND_HOST}/themepage/success?id=${
                      payData.orderId
                    }&zero=${0}`
                  }
                }
              })
              .catch((error) => {
                console.log('error:', error)
                this.showMessage = error.msg
                this.showToast = true
                setTimeout(() => {
                  this.showToast = false
                }, 3000)
              })
          } else {
            loading.clear()
          }
        })
        // .finally(() => loading.clear())
        .catch((error) => {
          console.log('error:', error)
          this.showMessage = '发起支付失败，请您尝试再次提交订单'
          this.showToast = true
          setTimeout(() => {
            this.showToast = false
          }, 3000)
        })
    },
    hasToast(message) {
      this.showMessage = message
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, 2000)
    },
    onClickLeft() {
      // this.$router.back(-1);
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.back(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-icon {
  color: black;
  font-size: 18px;
}

.orders {
  // position: fixed;
  width: 100%;
  height: 100%;
  background-color: #eee;
  padding-bottom: 1px;
  margin-bottom: 120px;
}
//navbar
.van-nav-bar {
  height: 44.5px;
  line-height: 44.5px;
  /deep/.van-nav-bar__text {
    font-size: 18px;
    color: black;
  }
  .van-nav-bar__arrow {
    font-size: 18px;
  }
}
//content_head
.content_head {
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 15px 15px 10px 15px;

  img {
    margin-right: 10px;
    width: 79px;
    height: 79px;
    border-radius: 7.5px;
  }
  .head_title {
    font-size: 15px;
    div {
      color: #969799;
      margin-top: 7.5px;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .head_price {
    .flex-price {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      width: 220px;
    }
    font-size: 12px;
    color: #969799;
    .price-num {
      padding-top: 6px;
    }
    .head-beforeMoney {
      font-size: 15px;
      color: black;

      .price-beforeMoney {
        font-size: 12px;
        text-decoration: line-through;
        color: #969799;
      }
    }
  }
  .head_tag {
    // text-align: right;
    .van-tag--default {
      padding: 2.5px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
}
//content
.content {
  width: 350px;
  margin: 10px 12.5px 10px;
  border-radius: 12.5px;
  overflow: hidden;
  //购买数量
  .pay-radius {
    border-radius: 0 0 12.5px 12.5px;
  }
  /deep/.pay-allradius {
    border-radius: 12.5px;
  }
  .pay-cardradius {
    border-radius: 12.5px 12.5px 0 0;
    background-color: #fff;
  }
  /deep/.pay_num {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 5px;
    .pay_title {
      font-size: 15px;
    }
    .pay_now {
      color: #c30d23;
    }
  }
  .pay-total {
    padding-top: 10px;
  }
  //服务方式
  .pay_service {
    padding: 0px 10px;
    font-size: 15px;
    .pay_explain {
      font-size: 12px;
      color: #969799;
    }
    .pay_radio {
      padding-top: 15px;
      padding-bottom: 15px;
      .van-radio-group--horizontal {
        height: 20px;
      }
      /deep/ .van-radio__icon {
        font-size: 12px;
      }
    }
  }
  //订单备注
  /deep/.pay_remark {
    border-radius: 12.5px;
    margin: 11px 0;
    .van-field__control {
      background-color: #efefef;
      border-radius: 5px;
      font-size: 12px;
    }
    .van-cell__title {
      width: auto;
    }
    .van-cell {
      border-radius: 8px;
      padding-left: 10px;
    }
  }
  //下拉菜单和服务信息
  .power_content {
    margin-top: 11px;
    background-color: #fff;
    padding-top: 11px;
    //提示警告框
    .showWarn {
      color: black;
      height: 133px;
      width: 275px;
      font-size: 15px;
      div {
        padding: 30px 30px 30px;
        text-align: center;
      }
      /deep/ .van-button--large {
        height: 40px;
        line-height: 40px;
      }
      /deep/ .van-button__text {
        font-size: 15px;
        color: black;
      }
    }
    /deep/ .power_show {
      position: relative;
      .from-store {
        position: absolute;
        right: 0;
        margin-right: 15px;
      }
      //上下边框
      .van-hairline--top-bottom::after,
      .van-hairline-unset--top-bottom::after {
        border-width: 0;
      }
      //弹窗宽度
      .van-dropdown-item--down {
        margin: 0 13px;
      }
      div {
        line-height: 20px;
      }
      padding: 0px 10px;
      font-size: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .van-dropdown-menu__title {
        font-size: 15px;
      }
    }
    //服务信息
    .power_detail {
      padding: 0px 10px;
      font-size: 12px;
      p {
        padding: 3px 0;
      }
      .again_store {
        padding: 0px 0px 10px;
        color: #3969e2;
      }
      .store-address {
        padding-left: 55px;
        text-indent: -55px;
        letter-spacing: 1px;
      }
    }
  }
}
//onsubmit提交
.onsubmit {
  // margin-top: 120px;
  .submit_main {
    padding: 5px 0px;
    line-height: 40px;
    .van-submit-bar__bar {
      height: 40px;
      padding: 0 5px;
    }
    .van-submit-bar__button {
      width: 150px;
      height: 40px;
    }
    .van-submit-bar__text {
      font-size: 12px;
      color: black;
    }
    .van-submit-bar__price {
      margin-left: 5px;
      font-size: 18px;
      color: #c30d23;
    }
    .van-button--normal {
      font-size: 15px;
    }
    .van-submit-bar__suffix-label {
      font-size: 12px;
      color: #9fa0a0;
    }
  }
}
//自提弹窗
/deep/ .self_proposal {
  .van-picker__toolbar {
    height: 40px;
    line-height: 40px;
  }
  .van-picker__title {
    font-size: 15px;
    color: black;
  }
  .van-picker-column__item {
    font-size: 15px;
  }
  .van-picker__cancel,
  .van-picker__confirm {
    font-size: 13px;
  }
}
//vant-load加载
/deep/ .vant-load {
  .van-loading__text {
    color: #1989fa;
  }
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11111;
}

.pay-cards {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px 0;
  .card-title {
    font-size: 15px;
  }
}
</style>
